import React from "react";
import { readDueInventoryItemConfig } from "../../utilities/dueInventoryItem";
import { dueStatus } from "../../utilities/monthYear";

export const DueBadge = ({ value, config }: { value: any; config: any }) => {
    const parsedConfig = readDueInventoryItemConfig(config);
    const status = parsedConfig ? dueStatus(value, parsedConfig.lifetimeYears, new Date()) : null;
    if (!status) {
        return null;
    }

    return (
        <small
            className="hidden-print"
            style={{
                display: "block",
                fontWeight: status.offered ? 600 : 400,
                color: status.overdue ? "#dc3545" : status.offered ? "#d97706" : "#6c757d",
            }}
        >
            {status.overdue
                ? `Austausch fällig seit ${status.expires}`
                : `Austausch fällig ${status.expires}`}
        </small>
    );
};
